import DTO from './DTO';

class VehiclesDTO extends DTO {
  device_id;

  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'device_id',
        type: String,
        validators: [],
        labelKey: 'device_id',
      },
      {
        name: 'timestamp',
        type: String,
        validators: [],
        labelKey: 'timestamp',
      },
      {
        name: 'stop_id',
        type: String,
        validators: [],
        labelKey: 'stop_id',
      },
      {
        name: 'created_at',
        type: String,
        validators: [],
        labelKey: 'created_at',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      device_id: this.device_id,
    };
  }
}

export default VehiclesDTO;
